/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Box } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import React, { useState } from "react";
import styles from "./DatePicker.styles";

function DatePicker({
  children,
  onDateSelect,
  disabled = false,
  disableFuture,
  minDate,
  maxDate,
}) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(new Date());

  const onToggle = () => {
    if (disabled) return;
    setOpen((prev) => !prev);
  };

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  const onSelectData = () => {
    const conferralDate = dayjs(value).format("MM/DD/YYYY");

    onDateSelect(conferralDate);
    setOpen(false);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        label="Date desktop"
        inputFormat="MM/DD/YYYY"
        open={open}
        value={value}
        maxDate={maxDate}
        disableFuture={disableFuture}
        minDate={minDate}
        onChange={handleChange}
        componentsProps={{
          actionBar: {
            actions: ["accept"],
            onAccept: onSelectData,
          },
        }}
        renderInput={(params) => (
          <>
            <Box style={styles.date} ref={params.inputRef} onClick={onToggle}>
              {children}
            </Box>
            {open && <Box style={styles.placeholder} onClick={onToggle} />}
          </>
        )}
      />
    </LocalizationProvider>
  );
}

export default DatePicker;
